import { render, staticRenderFns } from "./TeacherSickLeaveForm.vue?vue&type=template&id=4696cf49"
import script from "./TeacherSickLeaveForm.vue?vue&type=script&lang=js"
export * from "./TeacherSickLeaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports